import type * as FirebaseAuth from "firebase/auth"
import type { UpdateUserProfileRequest, UserDocument } from "popopo-msg"
import { useForm } from "react-hook-form"
import { api } from "../../core"
import { useToast } from "popopo-lib-front/hook"

export const UserProfileForm = (props: { firebase: FirebaseAuth.User; user: UserDocument }) => {
  const form = useForm<UpdateUserProfileRequest>({
    mode: "onBlur",
    defaultValues: {
      name: props.user.name,
      alias: props.user.alias,
    },
  })
  const toast = useToast()
  const { isSubmitting, isValid } = form.formState

  const onSubmit = async (value: UpdateUserProfileRequest) => {
    try {
      const idToken = await props.firebase.getIdToken()
      const res = await api.PUT("/api/v2/users/me/profile", {
        headers: {
          authorization: `Bearer ${idToken}`,
        },
        body: value,
      })
      if (res.data == null) {
        toast.add({ type: "danger", title: "プロフィール更新", message: JSON.stringify(res.error) })
      }
    } catch (e) {
      console.error(e)
      toast.add({ type: "danger", title: "プロフィール更新", message: e.message })
      throw e
    }
  }

  return (
    <form className="d-flex w-100 flex-column gap-3" onSubmit={form.handleSubmit(onSubmit)}>
      <div className="form-floating">
        <input className="form-control" {...form.register("name")} disabled={isSubmitting} />
        <label>Name</label>
      </div>

      <div className="form-floating">
        <input className="form-control" {...form.register("alias")} disabled={isSubmitting} />
        <label>Alias</label>
      </div>

      <button type="submit" className="btn btn-primary form-control" disabled={isSubmitting || !isValid}>
        Call &quot;PUT /users/me/profile&quot; API
      </button>
    </form>
  )
}
